import React from 'react';
import Records from './records';

const TransferRecords = () => {
  return <Records type="transfer" />;
};

export default TransferRecords;
